var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOptionalSignBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Sign_Here",
    "data-name": "Sign Here",
    xmlns: "http://www.w3.org/2000/svg",
    width: 122.648,
    height: 46.464,
    viewBox: "0 0 122.648 46.464",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5388",
    "data-name": "Group 5388",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Sign_Here-2",
    "data-name": "Sign Here",
    d: "M46.464,95.053a8.988,8.988,0,0,1-1.978,5.17L25.209,121.737a2.6,2.6,0,0,1-3.955,0L1.978,100.223A8.988,8.988,0,0,1,0,95.053V2.963A2.972,2.972,0,0,1,2.963,0H43.5a2.972,2.972,0,0,1,2.963,2.963Z",
    transform: "translate(0 46.464) rotate(-90)",
    fill: "#f0f0f0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionalSignBadge);
export default __webpack_public_path__ + "static/media/optionalSignBadge.5adb425eb5358e244c955b0b7a363f2f.svg";
export { ForwardRef as ReactComponent };